import {
  MenuOutlined,
  PrinterFilled,
  CloudSyncOutlined,
  UserSwitchOutlined,
  DollarOutlined,
  UserOutlined,
} from '@ant-design/icons';

export const dashboardBoxes = [
  {
    key: 'subscription',
    title: 'subscription List',
    type: 'navigation',
    route: '/subscription/list/',
    icon: (
      <DollarOutlined
        style={{ fontSize: '48px', height: '48px', width: '48px' }}
      />
    ),
    color: '#f0f5ff',
    borderColor: '#adc6ff',
  },
  {
    key: 'verison',
    title: 'Verison',
    type: 'navigation',
    route: '/verison/list/',
    icon: (
      <CloudSyncOutlined
        style={{ fontSize: '48px', height: '48px', width: '48px' }}
      />
    ),
    color: '#f6ffed',
    borderColor: '#b7eb8f',
  },
  {
    key: 'user',
    title: 'Admin Users',
    type: 'navigation',
    route: '/admin/user/list/',
    icon: (
      <UserOutlined
        style={{ fontSize: '48px', height: '48px', width: '48px' }}
      />
    ),
    color: '#fff7e6',
    borderColor: '#ffd591',
  },
];
